import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getAllLocations } from "services/locationService";

const LocationDropdown = ({ buttonText = "S'inscrire aux hebdos" }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [expandedGroup, setExpandedGroup] = useState(null);
  const dropdownRef = useRef(null);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      const data = await getAllLocations();
      const activeLocations = data.filter((loc) => loc.active === true);
      setLocations(activeLocations);
    };
    fetchLocations();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setExpandedGroup(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Group locations by name
  const groupedLocations = locations.reduce((acc, loc) => {
    acc[loc.name] = acc[loc.name] ? [...acc[loc.name], loc] : [loc];
    return acc;
  }, {});

  return (
    <div ref={dropdownRef} className="relative lg:ml-8">
      <button
        onClick={() => setDropdownOpen((prev) => !prev)}
        className="flex items-center gap-2 bg-amber-500 text-sm font-bold
          rounded-sm text-white px-2 md:px-4 py-2 hover:bg-amber-600 transition cursor-pointer"
      >
        {buttonText}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transform transition-transform ${
            dropdownOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </button>

      {dropdownOpen && (
        <div className="absolute right-0 top-12 md:top-10 min-w-full w-max bg-gray-900 text-white shadow-xl z-50">
          {Object.entries(groupedLocations).map(([name, group]) => (
            <div key={name} className="border-b border-gray-700">
              {group.length === 1 ? (
                <Link
                  to={`/locations/${group[0].id}`}
                  onClick={() => setDropdownOpen(false)}
                  className="block px-4 py-2 hover:bg-amber-700 transition-colors text-white"
                >
                  {name}
                </Link>
              ) : (
                <div>
                  <span
                    onClick={() => setExpandedGroup(expandedGroup === name ? null : name)}
                    className="block px-4 py-2 hover:bg-amber-700 transition-colors cursor-pointer text-white"
                  >
                    {name} {expandedGroup === name ? "▾" : "▸"}
                  </span>
                  {expandedGroup === name && group.map((loc) => (
                    <Link
                      key={loc.id}
                      to={`/locations/${loc.id}`}
                      onClick={() => { setDropdownOpen(false); setExpandedGroup(null); }}
                      className="block pl-8 pr-4 py-2 hover:bg-amber-600 transition-colors text-white whitespace-nowrap"
                    >
                      {loc.table || "Sans table"}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationDropdown;
